import { z } from "zod";
import UserRightScopeEnum from "../enums/UserRightScopeEnum";
import { userRightSchema } from "../services/bimVisualizerApi/schema/userRightSchema";

export default class UserRight {
    create: boolean;
    read: UserRightScopeEnum ;
    update: UserRightScopeEnum;
    delete: UserRightScopeEnum;

    constructor(
        create: boolean,
        read: UserRightScopeEnum,
        update: UserRightScopeEnum,
        del: UserRightScopeEnum
    ) {
        this.create = create;
        this.read = read;
        this.update = update;
        this.delete = del;
    }

    static fromSchema(obj: z.infer<typeof userRightSchema>) {
        return new UserRight(obj.create, obj.read, obj.update, obj.delete);
    }

    static NoRights(): UserRight {
        return new UserRight(false, UserRightScopeEnum.NoRights, UserRightScopeEnum.NoRights, UserRightScopeEnum.NoRights);
    }

    toString(): string {
        return `Create: ${this.create}, Read: ${this.read}, Update: ${this.update}, Delete: ${this.delete}`;
    }
}